<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateForm">
        <div class="container">
          <div class="row">
            <!-- Start:: Ar nationality -->
            <div class="col-lg-4 py-0">
              <div class="input_wrapper top_label">
                <input
                  @keypress="isArabic"
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty, addDataLocalStorage()"
                  v-model.trim="data.ar.nationality"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.nationality_ar") }}
                </label>
              </div>
            </div>
            <!-- End:: Ar nationality -->

            <!-- Start:: En nationality -->
            <div class="col-lg-4 py-0">
              <div class="input_wrapper top_label">
                <input
                  @keypress="isEnglish"
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty, addDataLocalStorage()"
                  v-model.trim="data.en.nationality"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.nationality_en") }}
                </label>
              </div>
            </div>
            <!-- End:: En nationality -->

            <!-- Start:: Is Active -->
            <div class="col-lg-12 py-0">
              <v-checkbox
                :label="$t('forms.labels.is_active')"
                v-model="data.is_active"
                color="success"
              ></v-checkbox>
            </div>
            <!-- End:: Is Active -->

            <!-- Start:: Map -->
            <!-- <div class="col-lg-12">
              <div class="input_wrapper top_label">
                <base-map
                  @markersChanged="merkersChanged"
                  :biggingMarkers="data.area"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.area") }}
                </label>
              </div>
            </div> -->
            <!-- end:: Map -->
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="button_style_1" :disabled="btnIsLoading">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",

  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.countries.title"),
          disabled: false,
          href: "/countries/show-all",
        },
        {
          text: this.$t("breadcrumb.countries.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== Data
      data: {
        flag: null,
        ar: {
          name: null,
          nationality: null,
          currency: null,
          slug: null,
        },
        en: {
          name: null,
          nationality: null,
          currency: null,
          slug: null,
        },
        // short_name: null,
        continent: null,
        timezone: null,
        phone_code: null,
        phone_number_limit: null,
        area: [],
        is_active: true,
        time_zone: null,
      },
      time_zones: [],
      // ========== Select Lists Data
    };
  },

  mounted() {
    this.getTimeZones();

    this.getDataLocalStorage();
  },

  methods: {
    // Uplode Image
    uplodeImg_1(link) {
      this.data.flag = link;
    },

    merkersChanged(data) {
      this.data.area = data;
    },

    addDataLocalStorage() {
      localStorage.setItem("country_data", JSON.stringify(this.data));
    },

    getDataLocalStorage() {
      if (localStorage.getItem("country_data")) {
        this.data = JSON.parse(localStorage.getItem("country_data"));
      }
    },

    // Empty Form Data
    emptyFormData() {
      this.data.flag = null;
      this.data.ar.name = null;
      this.data.en.name = null;
      this.data.ar.slug = null;
      this.data.en.slug = null;
      // this.data.short_name = null
      this.data.ar.currency = null;
      this.data.en.currency = null;
      this.data.continent = null;
      this.data.phone_code = null;
      this.data.is_active = null;
    },

    getZones() {
      this.$axios({
        method: "GET",
        url: "get_time_zones",
      }).then((res) => {
        this.timeZones = res.data.data.map((x) => {
          return {
            id: x,
            name: x,
          };
        });
      });
    },

    // Validate Data
    validateForm() {
      this.btnIsLoading = true;

      if (!this.data.ar.nationality) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.nationality"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.en.nationality) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.nationality"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      submit_data.append("ar[nationality]", this.data.ar.nationality);
      submit_data.append("en[nationality]", this.data.en.nationality);
      submit_data.append("is_active", +this.data.is_active);
      this.$axios({
        method: "POST",
        url: "nationality",
        data: submit_data,
      })
        .then(() => {
          // =============== End:: Remove Form Data From LocalStorage =============== //
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("addSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/nationality/show-all" });
          this.btnIsLoading = false;
          // this.emptyFormData();
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    getTimeZones() {
      this.$axios.get("get_time_zones").then((res) => {
        this.time_zones = res.data.data;
      });
    },
  },
  // mounted() {
  // this.getDataLocalStorage();
  // },
};
</script>
